export default "__VITE_ASSET__BY7k83ZY__"